import { registerSystemInfoTab } from "routes/sfg20-admin/plugins/system-info/register-system-info-tab"
import { Trends } from "routes/sfg20-admin/plugins/system-info/usage-trends-tab/trends"

registerSystemInfoTab("Usage Trends", <Trends $lazy />, 2)
